import React from 'react'
import { Menu } from 'antd'
import { Link } from 'react-router-dom'

export const MenuItems = () => {
  return (
    <Menu>
      <Menu.Item key="1">
        <Link to="/">Create validators for new wallet</Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="2" data-testid="logoutLink">
        <a href="mailto:help@gateway.fm">Contact us</a>
      </Menu.Item>
    </Menu>
  )
}
